import {HttpErrorResponse, HttpHandler, HttpInterceptor, HttpRequest} from "@angular/common/http";
import {Injectable} from "@angular/core";
import {TokenService} from "../app/services/token.service";
import {environment} from "../../environments/environment";
import {tap} from "rxjs";
import {Router} from "@angular/router";

@Injectable()
export class TokenInterceptor implements HttpInterceptor {
  readonly BASE_URL = environment.baseUrl;

  constructor(private tokenService: TokenService, private router: Router) {
  }

  intercept(req: HttpRequest<any>, next: HttpHandler) {
    if (req.url.startsWith(this.BASE_URL)) {
      const authReq = req.clone({
        headers: req.headers.set('Authorization', 'Bearer ' + this.tokenService.getAccessToken())
      });

      return next.handle(authReq).pipe(
        tap({
          error: (_error) => {
            // La LambdaAuthorizer in caso di token scaduto o non valido, genera una policy:Deny
            // Questa viene intercetta dalla API-Gateway che risponde con un 403: "User is not allow with an explicit deny"
            // Qui intercettiamo i 403 diretti, EVITARE di usare questo codice di errore lato Serverless
            // Farebbe partire il processo di logout

            // Il NAM potrebbe fornirci un username senza @ che non permette di recuperare il profilo necessario all'autorizzazione
            // È stato tutto gestito lato BackEnd sulla UserInfoLambda
            // Intercettiamo semplicemente il HTTPResponseCode 422 e forziamo una nuova login
            if (_error instanceof HttpErrorResponse && _error.status === 403 || _error.status === 422) {
              this.router.navigate(['end-session']);
            }
          }
        }),
      );
    } else {
      return next.handle(req);
    }
  }
}
